import makeSlice from '@web/slices/aitems/sliceMaker'

const aitemsSlice = makeSlice({})

export default aitemsSlice.reducer
